export default __webpack_public_path__ + "static/media/prj3.40db713e.jpg";